import { useRef } from "react";
import ShowItemContent from "../../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/Components/Custom Template Form/items/ShowItemContent";
import { isVisuallyEmptyTextEditor, removeTrailingEmptyLinesTextEditor } from "../../EHR Settings/Templates/OpenTemplate/FormBuilder/utils/utils";

const FormattingTextField = ({ item, isGroupNote }) => {
  let noValExistText = <p className="text ar-light-color">No data recorded</p>;
  let formattingNoteText = removeTrailingEmptyLinesTextEditor(item.content || '');
  let divContent =
    <>
      {isVisuallyEmptyTextEditor(item.content) ?
        noValExistText :
        <div className="ql-editor p-0 overflow-visible ql-view-content h-auto lh-normal"><p className="text" dangerouslySetInnerHTML={{ __html: formattingNoteText }}></p></div>}
    </>
  return (<>
    {item.content?.trim() ?
      <>
        {ShowItemContent(item, isGroupNote, divContent)}
      </> : <></>}
  </>
  )
}

export default FormattingTextField